import React, { useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Form, Button, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';


const ProductSalesReport = () => {
    const [startDate, setStartDate] = useState("2024-09-01");
    const [endDate, setEndDate] = useState("2024-09-30");
    const [groupBy, setGroupBy] = useState("");
    const [procedureFilter, setProcedureFilter] = useState("include");
    const [includeInactive, setIncludeInactive] = useState(false);
    const [quantityDisplay, setQuantityDisplay] = useState(false);
    const [byAttributes, setByAttributes] = useState(false);
    const [excludeMaterials, setExcludeMaterials] = useState(false);
    const [financeCharges, setFinanceCharges] = useState(false);
    const [credits, setCredits] = useState(false);
    const [format, setFormat] = useState("");

    const handleSubmit = (e) => {
        e.preventDefault();
        // Handle the form submission logic here
    };

    return (
        <div className="container mt-3">
            <div className="row justify-content-left">
                <div className="col-md-6">
                <h2 className="text-left mb-4 text-dark">Parameters</h2>
                    <Form onSubmit={handleSubmit} className="p-4 border rounded" id="report_product_sales" style={{ borderTop: '5px solid rgb(0, 123, 255)' }}>
                        <fieldset>
                          

                            <Form.Group as={Row} controlId="product-sales-start-date">
                                <Form.Label column md={4}>Start Date <span className="form_required" style={{ color: 'red' }}>*</span></Form.Label>
                                <Col md={8}>
                                    <Form.Control
                                        type="date"
                                        name="start_date"
                                        required
                                        value={startDate}
                                        onChange={(e) => setStartDate(e.target.value)}
                                        className="form-control"
                                    />
                                </Col>
                            </Form.Group>

                            <Form.Group as={Row} controlId="product-sales-end-date">
                                <Form.Label column md={4}>End Date <span className="form_required" style={{ color: 'red' }}>*</span></Form.Label>
                                <Col md={8}>
                                    <Form.Control
                                        type="date"
                                        name="end_date"
                                        required
                                        value={endDate}
                                        onChange={(e) => setEndDate(e.target.value)}
                                        className="form-control"
                                    />
                                </Col>
                            </Form.Group>

                            <Form.Group as={Row} controlId="report_product_sales_group_by">
                                <Form.Label column md={4}>Group By</Form.Label>
                                <Col md={8}>
                                    <Form.Control
                                        as="select"
                                        name="group_by"
                                        value={groupBy}
                                        onChange={(e) => setGroupBy(e.target.value)}
                                        className="form-control"
                                    >
                                        <option value="">None</option>
                                        <option value="category">Procedure Category</option>
                                    </Form.Control>
                                </Col>
                            </Form.Group>

                            <Form.Group as={Row}>
                                <Form.Label column md={4}>Procedures</Form.Label>
                                <Col md={8}>
                                    <Form.Check
                                        inline
                                        label="Include"
                                        type="radio"
                                        name="procedure_filter"
                                        value="include"
                                        checked={procedureFilter === "include"}
                                        onChange={(e) => setProcedureFilter(e.target.value)}
                                    />
                                    <Form.Check
                                        inline
                                        label="Exclude"
                                        type="radio"
                                        name="procedure_filter"
                                        value="exclude"
                                        checked={procedureFilter === "exclude"}
                                        onChange={(e) => setProcedureFilter(e.target.value)}
                                    />
                                </Col>
                            </Form.Group>

                            <Form.Group as={Row} controlId="report_product_sales_include_inactive">
                                <Col md={{ span: 8, offset: 4 }}>
                                    <Form.Check
                                        type="checkbox"
                                        name="include_inactive"
                                        label="Inactive Selectable?"
                                        checked={includeInactive}
                                        onChange={(e) => setIncludeInactive(e.target.checked)}
                                    />
                                </Col>
                            </Form.Group>

                            <Form.Group as={Row}>
                                <Form.Label column md={4}>Options</Form.Label>
                                <Col md={8}>
                                    <Form.Check
                                        type="checkbox"
                                        name="quantity_display"
                                        label="Display units columns"
                                        checked={quantityDisplay}
                                        onChange={(e) => setQuantityDisplay(e.target.checked)}
                                    />
                                </Col>
                            </Form.Group>

                            <Form.Group as={Row} controlId="report_product_sales_by_attributes">
                                <Col md={{ span: 8, offset: 4 }}>
                                    <Form.Check
                                        type="checkbox"
                                        name="by_attributes"
                                        label="Base report on Attributes"
                                        checked={byAttributes}
                                        onChange={(e) => setByAttributes(e.target.checked)}
                                    />
                                </Col>
                            </Form.Group>

                            <Form.Group as={Row} controlId="report_product_sales_exclude_materials">
                                <Col md={{ span: 8, offset: 4 }}>
                                    <Form.Check
                                        type="checkbox"
                                        name="exclude_materials"
                                        label="Exclude Materials and Alloys"
                                        checked={excludeMaterials}
                                        onChange={(e) => setExcludeMaterials(e.target.checked)}
                                    />
                                </Col>
                            </Form.Group>

                            <Form.Group as={Row} controlId="report_product_sales_finance_charges">
                                <Col md={{ span: 8, offset: 4 }}>
                                    <Form.Check
                                        type="checkbox"
                                        name="finance_charges"
                                        label="Include Finance Charges"
                                        checked={financeCharges}
                                        onChange={(e) => setFinanceCharges(e.target.checked)}
                                    />
                                </Col>
                            </Form.Group>

                            <Form.Group as={Row} controlId="report_product_sales_credits">
                                <Col md={{ span: 8, offset: 4 }}>
                                    <Form.Check
                                        type="checkbox"
                                        name="credits"
                                        label="Include Credits"
                                        checked={credits}
                                        onChange={(e) => setCredits(e.target.checked)}
                                    />
                                </Col>
                            </Form.Group>

                            <Form.Group as={Row} controlId="report_product_sales_format">
                                <Form.Label column md={4}>Format <span className="form_required" style={{ color: 'red' }}>*</span></Form.Label>
                                <Col md={8}>
                                    <Form.Control
                                        as="select"
                                        name="format"
                                        required
                                        value={format}
                                        onChange={(e) => setFormat(e.target.value)}
                                        className="form-control"
                                    >
                                        <option value="">On Screen</option>
                                        <option value="csv">CSV (Excel)</option>
                                    </Form.Control>
                                </Col>
                            </Form.Group>

                           <Form.Group as={Row}>
                                    <Col sm={{ span: 8, offset: 4 }}>
                                      <Link to="/Addproduct">
                                        <Button
                                          id="pay-per-task-submit"
                                          type="button"
                                          variant="primary"
                                          className="w-100 mt-2"
                                          style={{
                                            backgroundColor: '#004aad',
                                            borderColor: '#004aad',
                                            marginTop: '10px',
                                          }}
                                        >
                                          Run
                                        </Button>
                                      </Link>
                                    </Col>
                                   </Form.Group>
                        </fieldset>
                    </Form>
                </div>
            </div>
        
        </div>
    );
};

export default ProductSalesReport;
